/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/star-gray': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<mask id="svgicon_renewal_star-gray_a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="18" height="17"><path pid="0" d="M12.662 3.907l1.545 4.729c.091.282.353.475.651.479h5.016c.302 0 .569.192.662.478a.69.69 0 01-.252.773l-4.049 2.912a.687.687 0 00-.254.773l1.546 4.742a.69.69 0 01-.25.79.7.7 0 01-.834-.014l-4.048-2.911a.697.697 0 00-.82 0l-4.05 2.911a.7.7 0 01-.819 0 .69.69 0 01-.251-.776l1.559-4.73a.687.687 0 00-.25-.772l-4.05-2.912a.69.69 0 01.407-1.251h5.006a.693.693 0 00.65-.48l1.56-4.741a.696.696 0 011.325 0z" _fill="#fff"/></mask><g mask="url(#svgicon_renewal_star-gray_a)"><path pid="1" _fill="#AFAFAF" d="M0 0h24v24H0z"/></g>'
  }
})
